import clsx from "clsx";

export function cx(...classes) {
    return clsx(...classes);
}

// Formater la date
export const dateFormate = (dateStr) => {
    if (!dateStr) return "N/A";
    return new Date(dateStr).toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
    });
};

export const generateFilterTerminaux = (tab) => {
    if (tab.length > 0) {
        let filter = "&filter=";
        filter += tab.join(" and ");
        console.log(`Mon tableau ${tab.length}, la valeur ${filter}`);
        return filter;
    }
    return '';
};

export const formatCustomDate = (isoDate) => {

    console.log("isoDate", isoDate)

    const date = new Date(isoDate);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Mois commence à 0
    const year = String(date.getUTCFullYear()).slice(2); // On garde uniquement les deux derniers chiffres de l'année
    return `${day}/${month}/${year}`;
};


